import {mount} from 'svelte';

import SignupForm from '@js/components/layouts/Signup.svelte';

const target = document.getElementById('signup-form');

let signupForm;
if (target) {
    signupForm = mount(SignupForm, {target: target, props: {}});
}

export default signupForm;
